if (!customElements.get('custom-collection-controls')) {
  class CustomCollectionControls extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.section = this.closest('[id^="shopify-section-"]');
      this.addEventListener('click', (event) => {
        const label = event.target.closest('.products-toolbar__sort .label');
        const select = event.target.closest('.products-toolbar__sort custom-select');
        if (label || event.target === select) {
          event.preventDefault();
          if (select?.listboxOpen) select.hideListbox();
          else select?.showListbox?.();
        }
        this.removeFilter(event);
      }, options);
      this.addEventListener('keydown', (event) => {
        const select = event.target.closest('custom-select');
        if (event.key === 'Enter' && event.target === select?.button && !select.listboxOpen) {
          event.preventDefault();
          select.showListbox();
        }
      }, options);
      this.addEventListener('change', () => this.sortLabel(), options);
      this.section?.addEventListener('on:facet-filters:after-close', () => {
        this.querySelector('.js-toggle-filters')?.setAttribute('aria-expanded', 'false');
      }, options);
      this.section?.addEventListener('on:facet-filters:before-open', () => {
        this.querySelector('.js-toggle-filters')?.setAttribute('aria-expanded', 'true');
        this.querySelector('custom-select')?.hideListbox?.();
      }, options);
      this.update();
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    sortLabel() {
      const select = this.querySelector('custom-select');
      const button = select?.querySelector('.custom-select__btn');
      if (!button) return;
      button.setAttribute('aria-label', `${this.dataset.sortLabel}: ${button.firstElementChild.textContent.trim()}`);
    }

    update(source) {
      const summary = this.querySelector('[data-controls-summary]');
      if (source) {
        const status = this.querySelector('[data-controls-status]');
        const resultLabel = source.querySelector('.js-close-drawer-mob');
        if (status && resultLabel) status.textContent = resultLabel.textContent.trim();
        const next = source.querySelector('custom-collection-controls');
        const nextSummary = next?.querySelector('[data-controls-summary]');
        if (summary && nextSummary) {
          summary.innerHTML = nextSummary.innerHTML;
          summary.hidden = nextSummary.hidden;
          summary.dataset.filterCount = nextSummary.dataset.filterCount;
        }
        const currentSelect = this.querySelector('custom-select');
        const nextSelected = next?.querySelector('custom-select [aria-selected="true"]');
        if (currentSelect && nextSelected) {
          const options = [...currentSelect.querySelectorAll('.custom-select__option')];
          const selected = options.find((option) => option.dataset.value === nextSelected.dataset.value);
          if (selected) {
            options.forEach((option) => option.setAttribute('aria-selected', String(option === selected)));
            currentSelect.selectedOption = selected;
            currentSelect.listbox?.setAttribute('aria-activedescendant', selected.id);
            const button = currentSelect.querySelector('.custom-select__btn');
            if (button) button.firstElementChild.textContent = selected.firstElementChild.textContent;
          }
        }
      }
      const count = Number(summary?.dataset.filterCount || 0);
      const label = this.querySelector('[data-controls-filter-count]');
      if (label) label.textContent = count ? ` (${count})` : '';
      this.sortLabel();
    }

    setBusy(busy) {
      this.toggleAttribute('data-updating', busy);
      const summary = this.querySelector('[data-controls-summary]');
      if (summary) {
        if (busy) summary.setAttribute('aria-busy', 'true');
        else summary.removeAttribute('aria-busy');
      }
    }

    async removeFilter(event) {
      const link = event.target.closest('a[data-controls-remove]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const filters = this.section?.querySelector('facet-filters');
      if (!filters?.applyFilters) return;
      event.preventDefault();
      if (this.hasAttribute('data-updating')) return;
      const keyboard = event.detail === 0;
      const links = [...this.querySelectorAll('a[data-controls-remove]')];
      const index = links.indexOf(link);
      clearTimeout(filters.filterChangeTimeout);
      await filters.applyFilters(new URL(link.href).searchParams.toString(), event);
      if (keyboard && this.isConnected) {
        const remaining = [...this.querySelectorAll('a[data-controls-remove]')];
        const target = this.querySelector('[data-controls-summary]')?.hidden
          ? this.querySelector('.js-toggle-filters')
          : remaining[Math.min(index, remaining.length - 1)];
        target?.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('custom-collection-controls', CustomCollectionControls);
}
